// @ts-nocheck



import React, { Component } from 'react';


import { sortWaypoints } from './lib';
import { formatDateTimeToString } from './../../lib/helpers';
import ListTable from '../ui/ListTable';





/**
 * Маршрут в виде списка точек
 */
export default class WaypointsViewer extends Component {
  columns = [
  {
    title: 'Точка отправления',
    key: 'name'
  },
  {
    title: 'Время прибытия',
    key: 'arrivedDateTime',
    render: (arrivedDateTime) =>
    formatDateTimeToString(arrivedDateTime)
  },
  {
    title: 'Время отправления',
    key: 'departureDateTime',
    render: (departureDateTime) =>
    formatDateTimeToString(departureDateTime)
  },
  {
    title: 'Примечание',
    key: 'notation',
    render: (notation) => notation || '-'
  }];


  render() {
    const { waypoints } = this.props;
    return <ListTable data={sortWaypoints(waypoints)} columns={this.columns} />;
  }
}
